import React, { Component } from 'react';
import { Radio, Button } from 'antd';
import { PickMonthWrapper } from './style';

class PickMonth extends Component {
	state = {
		period: '1month'
	};

	handleClick = () => {
		const { onOk } = this.props;
		onOk(this.state.period);
	};

	render() {
		const style = {
			display: 'flex',
			alignItems: 'top',
			padding: '24px 0'
		};
		return (
			<PickMonthWrapper>
				<Radio.Group
					value={this.state.period}
					onChange={(v) => {
						this.setState({ period: v.target.value });
					}}
				>
					<Radio value="1month" style={style}>
						<div className="pick-month-radio-info">
							<div className="discount-label">0% OFF</div>
							<p>
								<b>1Month</b>
							</p>
							<p>10,000 XHT (0.1851 BTC)</p>
							<p>- $2,000 USDT</p>
						</div>
					</Radio>
					<Radio value="3month" style={style}>
						<div className="pick-month-radio-info">
							<div className="discount-label">2% OFF</div>
							<p>
								<b>3Month</b>
							</p>
							<p>29,400 XHT (0.3151 BTC)</p>
							<p>- $2,000 USDT</p>
						</div>
					</Radio>
					<Radio value="12month" style={style}>
						<div className="pick-month-radio-info">
							<div className="discount-label">5% OFF</div>
							<p>
								<b>12Month</b>
							</p>
							<p>114,000 XHT (0.8851 BTC)</p>
							<p>- $2,000 USDT</p>
						</div>
					</Radio>
				</Radio.Group>
				<Button block type="primary" onClick={this.handleClick}>
					Next
				</Button>
			</PickMonthWrapper>
		);
	}
}

export default PickMonth;
